import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import {
  skin,
  path,
  resolveContentCardSkins,
  groupContentsBySection
} from 'Utils'
import get from 'lodash/get'
import skins from '../skins'
import { PAGE_CONTEXT as p } from 'Constants'
import { ContentCard, ContentListItem, Icon, Link } from 'Blocks'

const mapStateToProps = state => {
  return {
    screenType: state.UI.screenType || ' '
  }
}

const ContentList = ({
  limit = 5,
  className = '',
  contents = [],
  pageName = '',
  gaContext = '',
  title = 'Get Inspired',
  intro = '',
  linkLabel = 'See more',
  withButtonIcon = false,
  screenType
}) => {
  if (pageName === 'homeArticles') {
    limit = screenType === 'medium' ? 4 : 5
  }

  if (
    pageName === 'noSearch' ||
    pageName === 'noSearchArticles' ||
    pageName === 'noSearchTrends' ||
    pageName === 'homeTrends' ||
    pageName === p.ARTICLE ||
    pageName === p.TREND ||
    pageName === p.PRODUCT ||
    pageName === `${p.PRODUCT}Instalooks` ||
    pageName === p.INSTALOOK
  ) {
    limit = screenType === 'medium' ? 3 : 4
  }

  if (pageName === p.PRODUCT || pageName === `${p.PRODUCT}Instalooks`) {
    contents = groupContentsBySection(contents, 'contentList')
  }

  const isHomeArticle = pageName === 'homeArticles'
  const firstArticle = contents[0]
  const startIndex = isHomeArticle ? 1 : 0
  let type = get(contents, '[0].type', 'article')
  if (type === 'insta') {
    type = 'instalook'
  }

  return contents && contents.length > 0 ? (
    <div className={`${className} article-list`}>
      <h2 className="article-list__title">{title}</h2>
      {intro && <h3 className="article-list__sub-title">{intro}</h3>}
      {isHomeArticle && (
        <ContentListItem pageName={gaContext || pageName} item={firstArticle} />
      )}
      <div className="article-list__grid">
        {contents.slice(startIndex, limit).map((article, index) => {
          return (
            <ContentCard
              pageName={pageName}
              gaContext={gaContext}
              key={`article-${article.uuid}`}
              position={index + 1}
              useCategoryName={true}
              variant={resolveContentCardSkins(pageName)}
              content={article}
            />
          )
        })}
      </div>
      <div className="article-list__cta">
        <Link
          data-cy={`${type}s_link`}
          className="cta"
          to={path(`${type}List`)}
        >
          {linkLabel}
          {withButtonIcon && <Icon name="back" />}
        </Link>
      </div>
    </div>
  ) : null
}

ContentList.propTypes = {
  className: PropTypes.string,
  contents: PropTypes.array,
  gaContext: PropTypes.string,
  intro: PropTypes.string,
  limit: PropTypes.number,
  linkLabel: PropTypes.string,
  pageName: PropTypes.string,
  screenType: PropTypes.string,
  title: PropTypes.string,
  withButtonIcon: PropTypes.bool
}

export default skin(connect(mapStateToProps, null)(ContentList), skins)
